import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ContactUsPageInitialData } from "./contactUsPageInitialData";

export const contactUsPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.contactUs(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<ContactUsPageInitialData>>("/page-data/contact-us"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
